// Compares a draft item against its published counterpart to determine
// whether it's brand new (never published), has unpublished edits on top
// of what's live ("modified"), or is fully in sync with what's live.
//
// Safe to compare with a plain JSON.stringify: after a real publish, the
// server rewrites the draft doc's image blobKeys to match the newly
// published ones exactly (see collections-publish.js / categories-publish.js
// step 2, which writes the same mutated doc to both stores), so an
// unmodified item's draft and published copies end up byte-identical — no
// need to special-case blobKey prefixes here.
export function publishStatus(draftItem, publishedList, keyField = 'slug') {
  if (!publishedList) return null; // published doc not loaded yet (or failed to load)
  const publishedItem = publishedList.find((p) => p[keyField] === draftItem[keyField]);
  if (!publishedItem) return 'new';
  return JSON.stringify(draftItem) === JSON.stringify(publishedItem) ? 'published' : 'modified';
}
